var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63684 6.91848L4.18766 0.550603H0.5V12.4495H4.36316V6.0806L8.81235 12.4495H12.5V0.550603H8.63684V6.91848Z",
    fill: "#03C75A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaver);
export default __webpack_public_path__ + "static/media/Naver.645f7efe7bca777dcbc073d09bac37fe.svg";
export { ForwardRef as ReactComponent };